import { render, staticRenderFns } from "./ReadRelatorio.vue?vue&type=template&id=1df3dd50"
import script from "./ReadRelatorio.vue?vue&type=script&lang=js"
export * from "./ReadRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports